import { useCallback, useEffect, useState } from 'react';

import { toast } from 'sonner';
import Honeybadger from '@honeybadger-io/js';

import { deserializer } from '../../../../shared/utils/deserializer';
import { usePagination } from '../../../shared/hooks';
import { fetchDecedents as apiFetchDecedents } from '../services/decedentService';
import useDecedentFilters from './useDecedentFilters';

const useDecedentData = (searchQuery) => {
  const [decedents, setDecedents] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const { activeFilters } = useDecedentFilters();
  const { handlePageChange, pagination, updatePagination } = usePagination();

  const fetchDecedents = useCallback(async () => {
    setIsLoading(true);

    try {
      const response = await apiFetchDecedents({
        activeFilters,
        decedentName: searchQuery,
        page: pagination.currentPage,
        perPage: pagination.perPage,
      });

      const decedents = await deserializer.deserialize(response);

      setDecedents(decedents);
      updatePagination(response.meta.pagination);
    } catch (error) {
      toast.error(error.message);
      Honeybadger.notify(error);
    } finally {
      setIsLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeFilters, pagination.currentPage, pagination.perPage, searchQuery]);

  useEffect(() => {
    fetchDecedents();
  }, [fetchDecedents]);

  return {
    decedents,
    fetchDecedents,
    handlePageChange,
    isLoading,
    pagination,
  };
};

export default useDecedentData;
